// Eskom PARCC — semicircular risk gauge (inline SVG, theme-aware).
//
// A deterministic SVG arc (no chart lib) showing a 0..max risk index with a
// green→amber→red sweep, the reading in the centre, and a band label. Adopted
// from concept B for the operational sections.
export function RiskGauge({
  value,
  max = 3,
  ok,
  warn,
  bad,
  track,
  bandLabel,
  height = 150,
}: {
  value: number;
  max?: number;
  ok: string;
  warn: string;
  bad: string;
  track: string;
  bandLabel: string;
  height?: number;
}): React.JSX.Element {
  const pct = Math.max(0, Math.min(1, value / max));
  // Semicircle arc length for r=18 ≈ π*18 ≈ 56.5 (viewBox units).
  const ARC = 56.5;
  const id = 'dz-gauge-grad';
  return (
    <div className="dz-gauge">
      <svg width="100%" height={height} viewBox="0 0 42 26" preserveAspectRatio="xMidYMid meet" role="img" aria-label={`Risk index ${value} of ${max}`}>
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor={ok} />
            <stop offset="60%" stopColor={warn} />
            <stop offset="100%" stopColor={bad} />
          </linearGradient>
        </defs>
        <path d="M3 23 A18 18 0 0 1 39 23" fill="none" stroke={track} strokeWidth="4.4" strokeLinecap="round" />
        <path
          d="M3 23 A18 18 0 0 1 39 23"
          fill="none"
          stroke={`url(#${id})`}
          strokeWidth="4.4"
          strokeLinecap="round"
          strokeDasharray={ARC}
          strokeDashoffset={ARC * (1 - pct)}
        />
      </svg>
      <div className="read" style={{ color: 'var(--text)' }}>
        {value.toFixed(2)}
      </div>
      <div className="sub">
        of {max.toFixed(1)} · {bandLabel}
      </div>
    </div>
  );
}
